import React, { useState } from "react";
import {
  ProSidebar,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
  Menu,
  SubMenu,
  MenuItem,
} from "react-pro-sidebar";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, Outlet } from "react-router-dom";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import Logo from "../../assets/icons/sidebarIcon/logo.png";
import LogoSM from "../../assets/icons/sidebarIcon/logo-sm.png";
import {
  DashboardIcon,
  CreateBusinessIcon,
  ReportIcon,
} from "../../assets/icons/sidebarIcon";
import { useNavigate } from "react-router-dom";
import { AiOutlineLogout } from "react-icons/ai";

import "react-pro-sidebar/dist/css/styles.css";
import "./sidebar.css";
const SideBar = () => {
  const navigate = useNavigate();
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [toggled, setToggled] = useState(false);
  const role = localStorage.getItem("role");
  const menuIconClick = () => {
    menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
  };
  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  const logoutHandler = () => {
    const role = localStorage.getItem("role");
    localStorage.clear();
    navigate(`${role === "investor" ? "/login/investor" : "/login/business"}`);
  };
  const title =
    role === "investor" ? "Investor Dashboard" : "Business Dashboard";
  return (
    <>
      <aside className="h-screen relative">
        <button
          className="fixed top-[20px] left-[10px]"
          onClick={() => handleToggleSidebar(true)}
        >
          <GiHamburgerMenu size={24} />
        </button>
        <ProSidebar
          collapsed={menuCollapse}
          breakPoint="md"
          toggled={toggled}
          onToggle={handleToggleSidebar}
          className="fixed"
        >
          <SidebarHeader className="h-10 py-10 flex justify-center items-center px-3 border-b-0 relative w-full">
            <Link
              to={
                localStorage.getItem("role") === "investor"
                  ? "/investor/dashboard"
                  : "/business/dashboard"
              }
              classes="flex h-full"
            >
              {!menuCollapse ? (
                <img src={Logo} alt="..." className="max-h-fit duration-500" />
              ) : (
                <img src={LogoSM} alt="..." width={24} />
              )}
            </Link>
          </SidebarHeader>
          <SidebarContent className="pt-5">
            <Menu popperArrow={true}>
              <SubMenu
                title={title}
                icon={
                  <img src={DashboardIcon} width={24} alt="Dashboard-Icon" />
                }
              >
                <MenuItem className="">
                  <Link
                    to={
                      role === "investor"
                        ? "/investor/dashboard/revenue-business"
                        : "/business/dashboard/revenue-business"
                    }
                  >
                    Business Total Revenue
                  </Link>
                </MenuItem>
                <MenuItem className="">
                  <Link
                    to={
                      role === "investor"
                        ? "/investor/dashboard/total-business"
                        : "/business/dashboard/total-business"
                    }
                  >
                    Business Unit
                  </Link>
                </MenuItem>
                <MenuItem className="">
                  <Link
                    to={
                      role === "investor"
                        ? "/investor/dashboard/value-business"
                        : "/business/dashboard/value-business"
                    }
                  >
                    Business Valuation
                  </Link>
                </MenuItem>
              </SubMenu>
              <MenuItem
                icon={
                  <img
                    src={CreateBusinessIcon}
                    width={24}
                    alt="CreateBusiness-Icon"
                  />
                }
              >
                <Link
                  to={
                    role === "investor"
                      ? "/investor/dashboard/our-business"
                      : "/business/dashboard/our-business"
                  }
                >
                  Our Business
                </Link>
              </MenuItem>
              {localStorage.getItem("role") === "business" && (
                <MenuItem
                  icon={
                    <img
                      src={CreateBusinessIcon}
                      width={24}
                      alt="CreateBusiness-Icon"
                    />
                  }
                >
                  <Link
                    to={
                      role === "investor"
                        ? "/investor/dashboard/our-business"
                        : "/business/dashboard/total-business/list"
                    }
                  >
                    Mangement Business Unit
                  </Link>
                </MenuItem>
              )}
              {localStorage.getItem("role") === "business" && (
                <MenuItem
                  icon={
                    <img
                      src={CreateBusinessIcon}
                      width={24}
                      alt="CreateBusiness-Icon"
                    />
                  }
                >
                  <Link
                    to={
                      role === "investor"
                        ? "/investor/dashboard/our-business"
                        : "/business/dashboard/category-business"
                    }
                  >
                    Mangement Category Unit
                  </Link>
                </MenuItem>
              )}
              <MenuItem
                icon={<img src={ReportIcon} width={24} alt="Report-Icon" />}
              >
                <Link
                  to={
                    role === "investor"
                      ? "/investor/dashboard/report"
                      : "/business/dashboard/report"
                  }
                >
                  Report
                </Link>
              </MenuItem>
              <MenuItem
                icon={
                  <AiOutlineLogout
                    onClick={logoutHandler}
                    color="white"
                    style={{ height: "32px", width: "32px" }}
                  />
                }
                width={24}
              >
                <button
                  type="submit"
                  onClick={logoutHandler}
                  className="w-full text-left"
                >
                  Logout
                </button>
              </MenuItem>
            </Menu>
          </SidebarContent>
          <SidebarFooter className="flex justify-start pl-6 items-center h-full">
            <button className="btn" onClick={menuIconClick}>
              {menuCollapse ? (
                <MdKeyboardArrowRight size={24} />
              ) : (
                <MdKeyboardArrowLeft size={24} />
              )}
            </button>
          </SidebarFooter>
        </ProSidebar>
      </aside>
      <Outlet />
    </>
  );
};

export default SideBar;
